import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { SelectedCounter, BatchActionsBar } from '@components/Albums/style';
import Button, { SIZE, VARIANT } from '@components/Button';
import { albumBatchOptions, stemBatchOptions } from '@app/consts';

const selectStyles = {
  container: provided => ({
    ...provided,
    width: '100%',
    maxWidth: '300px',
  }),
};

const BatchActions = ({ albumsSize, downloadBatch, reset, stems }) => {
  const selectChangeHandler = useCallback(option => downloadBatch(option), []);

  return (
    <BatchActionsBar>
      <Select
        options={stems ? stemBatchOptions : albumBatchOptions}
        placeholder="Batch actions"
        styles={selectStyles}
        isSearchable={false}
        onChange={selectChangeHandler}
        value=""
      />

      <SelectedCounter>
        {albumsSize} selected albums
        <Button
          type="button"
          text="CLEAR SELECTED"
          size={SIZE.SMALL}
          variant={VARIANT.TERTIARY}
          onClick={reset}
        />
      </SelectedCounter>
    </BatchActionsBar>
  );
};

BatchActions.propTypes = {
  albumsSize: PropTypes.number.isRequired,
  reset: PropTypes.func.isRequired,
  downloadBatch: PropTypes.func.isRequired,
};

export default memo(BatchActions);
